<template>
  <!-- :bodyStyle="{paddingTop:'10px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px',paddingLeft:'24px'}">
    <search-page-view
      ref="table"
      rowKey="orderNo"
      :itemNames="['search_orderNo','search_pftOrderNo','create_button',]"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_orderNo" label="关联销售订单号" v-bind="formItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入关联销售订单号"></a-input>
      </a-form-item>
      <a-form-item slot="search_pftOrderNo" label="票付通订单号" v-bind="formItemLayout">
        <a-input v-model="queryParams.pftOrderNo" placeholder="请输入票付通订单号"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
      </a-form-item>
      <template slot="personSlots" slot-scope="data">
        <div>{{ data.record.memberName }}</div>
        <div>{{ data.record.memberMobile }}</div>
      </template>
      <template slot="action" slot-scope="rowItem">
        <template v-if="rowItem.record.manuallyCreateOrder==0">
          <a @click="confirmUpdate(rowItem.record,1)">确认</a>
          <a-divider type="vertical"></a-divider>
          <a @click="confirmUpdate(rowItem.record,2)">拒绝</a>
        </template>
      </template>
    </search-page-view>
    <a-modal :title="ruleForm.orderStatus==1?'确认订单':'拒绝订单'" :visible="popupVisible" width="550px" :footer="null"
             @cancel="handleCancel">
      <a-form-model :model="ruleForm" ref="ruleForm" :rules="rules"
                    :label-col="currentFormLayout.labelCol"
                    :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item v-if="ruleForm.orderStatus==1" label="票付通订单号" prop="pftOrderNo">
          <a-input v-model="ruleForm.pftOrderNo" placeholder="请输入票付通订单号" :maxLength="30"/>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="orderRemark">
          <a-textarea v-model="ruleForm.orderRemark" placeholder="请输入备注" :maxLength="100"
                      :auto-size="{ minRows: 2, maxRows: 6 }" allow-clear/>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
          <a-button type="primary" @click="handleSubmit" :loading="submitLoading">提交</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
export default {
  name: 'SyncTicketOrder',
  components: {},
  data() {
    return {
      popupVisible: false,
      submitLoading: false,
      queryParams: {
        orderNo: '', //名称
        pftOrderNo: ''
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '票付通订单号',
          dataIndex: 'pftOrderNo'
        },
        {
          title: '关联销售订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '商品名称',
          dataIndex: 'proName'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '下单用户',
          dataIndex: 'memberName',
          scopedSlots: { customRender: 'personSlots' }
        },
        {
          title: '订单来源',
          dataIndex: 'orderSource'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatusStr'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ],
      currentFormLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 }
      },
      formItemLayout: {
        labelCol: {
          xxl: { span: 7 },
          xl: { span: 7 },
          lg: { span: 8 },
          sm: { span: 9 },
          md: { span: 10 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 17 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 17 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 16 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 15 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 14 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      ruleForm: {
        orderNo: '',// 平台订单号
        orderSource: '',// 订单来源
        orderStatus: 1,// 订单状态 1 确认订单 2 拒绝订单
        pftOrderNo: '',// 票付通订单号
        orderRemark: ''
      },
      rules: {
        pftOrderNo: [
          { required: true, message: '请输入票付通订单号', trigger: 'blur' }
        ],
        orderRemark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'SyncTicketPro', title: '同步商品' },
      { name: 'SyncTicketOrder', title: '订单直连' },
      { name: 'RelAccount', title: '关联账号' }
    ])
  },
  activated() {

  },
  methods: {
    handleCancel() {
      this.popupVisible = false
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getOrderService().post('pft/getPFTOrderList', params)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    submitData() {
      this.submitLoading = true
      this.getHttpServices().getOrderService().post('pft/manually/confirm/order', this.ruleForm).then(res => {
        this.getLogUtils().logWithTag('submitData', res)
        this.$message.success(this.ruleForm.orderStatus == 1 ? '确认订单成功' : '拒绝订单成功')
        this.$refs.table.refresh(true)
        this.popupVisible = false
      }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
    },
    confirmUpdate(data, status) {
      this.popupVisible = true
      this.ruleForm.orderNo = data.orderNo// 平台订单号
      this.ruleForm.orderSource = data.orderSource// 订单来源
      this.ruleForm.orderStatus = status// 订单状态 1 确认订单 2 拒绝订单
    }
  }
}
</script>
<style scoped lang="less">

</style>